import { render } from "./SuggestionComponent.vue?vue&type=template&id=19e92f8a"
import script from "./SuggestionComponent.vue?vue&type=script&lang=js"
export * from "./SuggestionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__